import heroFilter from '../modules/hero-filter';
import browseGrid from '../modules/browse-grid';

export default {
  init() {
    // JavaScript to be fired on the Category Page
    // on load, hide the collection tiles
    // To select collection tiles, select all
    // category hero markup then get the next item
    const categoryHeros = document.querySelectorAll('.ms-category-hero');
    const collectionTiles = categoryHeros[1];
    if (collectionTiles) {
      collectionTiles.style.display = 'none';

      // If collection tiles module is the last module, set the previous sibling's
      // margin-bottom to 0 to prevent display of extra space.
      const lastModuleElement = document.querySelector('.ms-module:last-child');

      if (collectionTiles === lastModuleElement) {
        collectionTiles.previousElementSibling.style.marginBottom = '0px';
      }
    }

    heroFilter.init();
    browseGrid.init();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/routes/templateBrowse.js